/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

let $ = jQuery;
import template from "lodash/template";

let _formats = {
	leader: [728, 90],
	leader_addl: [728, 90],
	box: [300, 250],
	box_addl: [300, 250],
	sky: [160, 600],
	sky_r: [160, 600],
	half_page: [300, 600],
	leader_billboard: [970, 250],
	logout: [800, 600],
};

let _template_appnexus = template(`\
<div id="<%= id %>" class="ad format format--<%= format %>"></div>\
`);

window.DisplayAds = {
	formats: _formats,

	// 6 seconds
	focusRefreshInterval: 6000,

	// 3 minutes
	idleRefreshInterval: 180000,

	adRefreshCooldown: 10000,

	init() {
		this.listen();
		this.restartIdleTimeout();
		this.lastFocusTime = 0;
		return (this.lastBlurTime = 0);
	},

	listen() {
		$(window).on("focus", () => {
			this.lastFocusTime = new Date().getTime();
			if (
				this.lastBlurTime &&
				this.lastBlurTime + this.focusRefreshInterval < this.lastFocusTime
			) {
				this.refreshAll("focus");
				return this.restartIdleTimeout();
			}
		});
		return $(window).on("blur", () => {
			return (this.lastBlurTime = new Date().getTime());
		});
	},

	restartIdleTimeout() {
		// Temporarily disable, find a smarter way to do this and ensure that the
		// user is still "active."
		return;

		clearTimeout(this.idleRefreshTimeout);
		return (this.idleRefreshTimeout = setTimeout(() => {
			if (document.hasFocus()) {
				this.refreshAll("idle");
			}
			return this.restartIdleTimeout();
		}, this.idleRefreshInterval));
	},

	getDimensions(format) {
		return _formats[format];
	},

	getUrl(format, params = null) {
		let args = {
			base: 1,
			authid: ACCESS_TOKEN,
			pageurl: window.location.pathname,
			cachebust: Math.random(1000000),
			page: Context.get("daisyPage"),
			format,
		};

		if (
			(typeof SESSION !== "undefined" && SESSION !== null
				? SESSION.acct_level
				: undefined) === 6
		) {
			let [width, height] = this.getDimensions(format);
			args.fakead = 1;
			args.width = width;
			args.height = height;
		}

		if (params && typeof params === "object") {
			args = {
				...args,
				...params,
			};
		}

		return Context.get("daisyUrl") + "?" + $.param(args);
	},

	getAd(format, params = null) {
		let id = `div-gpt-ad-DISPLAYADS-${format}-${Math.random()}`;

		setTimeout(() => {
			return typeof OnPageAds !== "undefined" && OnPageAds !== null
				? OnPageAds.addAd({ id, format })
				: undefined;
		}, 10);

		return _template_appnexus({ id, format });
	},

	getFormat(el) {
		// firstly, try the data attribute
		let format = el.data("format");
		if (format && _formats[format]) {
			return format;
		}

		// otherwise, search by width and height
		let width = el.width();
		let height = el.height();
		for (format of Object.keys(_formats || {})) {
			let [fwidth, fheight] = _formats[format];
			if ((width = fwidth && (height = fheight))) {
				return format;
			}
		}

		// otherwise give up
		return null;
	},

	// Given an iframe HTML element, refresh that shit
	refresh(el, opts) {
		// iframes only, bub
		if (opts == null) {
			opts = {};
		}
		el = $(el);

		if (el.prop("tagName") !== "IFRAME") {
			el = el.find("iframe");
		}
		if (!el.length) {
			return;
		}
		let parent = el.parent();

		// Check for a refresh cooldown
		if (parent.data("refresh-cooldown")) {
			return;
		}

		// don't replace ads with a takeover
		if (el.hasClass("takeover")) {
			return;
		}

		// get the format
		let format = opts.format || this.getFormat(el);
		if (!format) {
			return;
		}

		// check if the ad has special params
		let params = el.data("params") || null;

		// params are in querystring format. convert to an object.
		if (params && params !== "") {
			params = params.split("&").reduce(function(memo, pair) {
				if (!pair) {
					return memo;
				}
				pair = pair.split("=");
				memo[pair[0]] = pair[1];
				return memo;
			}, {});
		}

		let newAd = this.getAd(format, params);
		el.replaceWith(newAd);

		// Set a cooldown to prevent this from refreshing again for a bit.
		parent.data("refresh-cooldown", true);
		setTimeout(
			() => parent.data("refresh-cooldown", false),
			this.adRefreshCooldown
		);

		// And of course, fire off stats. Add sources to clientstats.dict.
		let format_s = format.replace("_addl", "");
		let stats = [];
		stats.push("ads - ad refreshed");
		stats.push(`ads - ad refreshed - format:${format_s}`);
		if (opts.source) {
			stats.push(`ads - ad refreshed - source:${opts.source}`);
			stats.push(
				`ads - ad refreshed - source:${opts.source} - format:${format_s}`
			);
		}
		return ClientStats.update({ statnames: stats });
	},

	refreshAll(source) {
		// let admins disable refreshAll on focus
		if (
			source === "focus" &&
			typeof DISABLE_FOCUS_REFRESH !== "undefined" &&
			DISABLE_FOCUS_REFRESH !== null &&
			DISABLE_FOCUS_REFRESH
		) {
			return;
		}

		if (Context.get("appNexusDirect")) {
			return typeof OnPageAds !== "undefined" && OnPageAds !== null
				? OnPageAds.refreshAds()
				: undefined;
		}

		let viewHeight = $(window).height();

		$("iframe").each((idx, el) => {
			if (!el.src || el.src.indexOf("daisy") === -1) {
				return;
			}

			// Must be vertically at least halfway in the viewport
			let bounds = el.getBoundingClientRect();
			if (
				bounds.top + bounds.height * 0.5 > 0 &&
				bounds.top + bounds.height * 0.5 < viewHeight
			) {
				return this.refresh(el, { source });
			}
		});
		return true;
	},

	updateStats(format) {
		let loginstring = CURRENTUSERID === "0" ? "logged out" : "logged in";
		let suffix = "new:all - newaccount:no";

		// pretend _addls are vanilla
		let format_s = format.replace("_addl", "");

		let s = [];

		s.push(`ads - ad shown - ${loginstring}`);
		s.push(`ads - ad shown - ${loginstring} - format:${format_s}`);
		s.push(
			`ads - ad shown - ${loginstring} - page:${Context.get("daisyPage")}`
		);

		return ClientStats.update({ statnames: s });
	},
};

$(document).on("ready", () => DisplayAds.init());



// WEBPACK FOOTER //
// ./src/legacy/displayads.js